import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OrganisationClientVM } from '../../../models/OrganisationClientVM';
import { BaseComponent } from '../../base/base.component';
import { AccountService } from '../../../services/account.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { SessionDuration } from '../../../models/SessionDuration';
import { OrganisationIssueCreditVM } from '../../../models/OrganisationIssueCreditVM';

@Component({
  selector: 'clients',
  templateUrl: './clients.component.html'
})
export class ClientsComponent extends BaseComponent implements OnInit {

  //0 = client screens
  //1 = Step 1
  //2 = Step 2
  //3 = Success
  //4 = Failed
  mode: number = 0;

  issueSessionTo: OrganisationIssueCreditVM = new OrganisationIssueCreditVM();

  filter: string = '';
  filterStatus: boolean = true;

  clientData: OrganisationClientVM[] = [];
  clientTable: OrganisationClientVM[] = [];
  newClient: OrganisationClientVM = new OrganisationClientVM();

  constructor(private router: Router,
    private route: ActivatedRoute,
    private accService: AccountService,
    private fb: FormBuilder
  ) {
    super(route);
  }

  ngOnInit(): void {

    // initial data load
    this.reloadData(null, true);

    this.myForm = this.fb.group({
      username: new FormControl('', [Validators.required, Validators.email])
    });

  }

  addClient() {
    this.markAsTouched(this.myForm);
    if (this.myForm.valid) {
      this.emitDisplayLoadingDialog(true);
      this.accService.addClient(this.newClient)
        .subscribe(
          r => {
            this.emitDisplayLoadingDialog(false);
            if (r) {
              this.showDialog("Client added successfully", false);
            }
            else {
              this.showDialog("Failed to add client", true);
            }

            this.reloadData(null, false);
          },
          e => {
            console.log(e);
            this.showDialog(e, true);
            this.emitDisplayLoadingDialog(false);
          }
        );
    }
  }

  filterClients() {
    var callback = () => {
      if (this.filter.length > 0) {
        // email filter str
        this.clientTable = this.clientData.filter((item, i) => {
          return (item.username.startsWith(this.filter));
        });
      }
    };

    this.reloadData(callback, true);
  }

  toggleClientStatus(item: OrganisationClientVM) {
    if (item.enabled) {
      this.emitDisplayLoadingDialog(true);
      this.accService.enableClient(item)
        .subscribe(
          r => {
            this.emitDisplayLoadingDialog(false);
            if (r) {
              this.showDialog("Client enabled successfully", false);
            }
            else {
              this.showDialog("Failed to enabled client", true);
            }

            this.reloadData(null, false);
          },
          e => {
            console.log(e);
            this.showDialog(e, true);
            this.emitDisplayLoadingDialog(false);
          }
        );
    }
    else {
      this.accService.disableClient(item)
        .subscribe(
          r => {
            this.emitDisplayLoadingDialog(false);
            if (r) {
              this.showDialog("Client disabled successfully", false);
            }
            else {
              this.showDialog("Failed to disable client", true);
            }

            this.reloadData(null, false);
          },
          e => {
            console.log(e);
            this.showDialog(e, true);
            this.emitDisplayLoadingDialog(false);
          }
        );
    }
  }

  reloadData(callback: () => void | null, withLoadingOverlay: boolean) {
    if (withLoadingOverlay) {
      this.emitDisplayLoadingDialog(true);
    }

    this.accService.getClients(this.filterStatus).subscribe(
      r => {
        this.clientData = r;
        this.clientTable = r;

        if (callback != null) {
          callback();
        }

        if (withLoadingOverlay) {
          this.emitDisplayLoadingDialog(false);
        }
      },
      e => {
        console.log(e);
        if (withLoadingOverlay) {
          this.emitDisplayLoadingDialog(false);
        }
      }
    );
  }

  issueSession(item: OrganisationClientVM) {
    this.issueSessionTo.issuedTo = item.username;
    this.mode = 1;
  }

  issueSessionSelectDuration(duration: SessionDuration) {
    this.issueSessionTo.duration = duration;
    this.mode = 2;
  }

  issueSessionConfirm() {
    this.emitDisplayLoadingDialog(true);
    this.accService.issueSession(this.issueSessionTo)
      .subscribe(
        r => {
          if (r) {
            this.mode = 3;
          }
          else {
            this.mode = 0;
            this.showDialog("Failed to issue session - Insufficient credits", true);
          }
          this.emitDisplayLoadingDialog(false);
        }
        ,
        e => {
          console.log(e);
          this.cancelIssueSession();
          this.showDialog(e, true);
          this.emitDisplayLoadingDialog(false);
        }
      );
  }

  cancelIssueSession() {
    this.issueSessionTo = new OrganisationIssueCreditVM();
    this.mode = 0;
  }

}
